export const DEFAULT_ALERT_LEVELS: Record<string, Record<number, string>> = {
  DevStreamEventFcw: { 1: 'urgent' },
  DevStreamEventPcw: { 1: 'urgent' },
  DevStreamEventLdw: { 1: 'low' }, // TODO: assign or delete
  DevStreamEventOverspeed: { 1: 'medium' },
  DevStreamEventWireCut: { 1: 'urgent' },
  DevStreamEventDrowsiness: { 1: 'low', 2: 'medium', 3: 'urgent' },
  DevStreamEventEyesOffRoad: { 1: 'medium' },
  DevStreamEventCameraBlockageInterior: { 1: 'urgent' },
  DevStreamEventCameraBlockageExterior: { 1: 'urgent' },
  DevStreamEventMobilePhoneUsage: { 1: 'medium' },
  DevStreamEventTailgaiting: { 1: 'low' },
  DevStreamEventAccidentCameraRemoval: { 1: 'low' }, // TODO: assign or delete
  DevStreamEventHighG: { 1: 'medium', 2: 'urgent' },
  DevStreamEventHardBrake: { 1: 'medium' },
  DevStreamEventHardAcceleration: { 1: 'medium' },
  DevStreamEventHardTurn: { 1: 'medium' },
  DevStreamDriverNotFound: { 1: 'urgent' },
  DevStreamUnauthorizedDriver: { 1: 'urgent' },
  DrivingOvertime: {
    1: 'medium', 2: 'medium', 3: 'medium', 4: 'medium',
  },
  DriverUnauthorized: { 1: 'urgent' },
  DriverUnknown: { 1: 'urgent' },
};

export const ALERT_AUDIO_NAMES = {
  eventDrowsinessLevel2: 'Drowsiness warning (Level 2)',
  eventDrowsinessLevel3: 'Drowsiness warning (Level 3)',
  eventEyesOffRoadLevel1: 'Eyes Off the Road warning (Level 1)',
  eventFcwLevel1: 'Forward collision warning (Level 1)',
  eventPcwLevel1: 'Pedestrian collision warning (Level 1)',
  eventLdwLevel2: 'Lane departure warning (Level 2)',
  eventHardAccelerationLevel1: 'Hard acceleration warning (Level 1)',
  eventHardBrakeLevel1: 'Hard brake warning (Level 1)',
  eventHardTurnLevel1: 'Hard turn warning (Level 1)',
  eventOverspeedLevel1: 'Over speeding warning (Level 1)',
  eventMobilePhoneUsageLevel1: 'Mobile phone usage warning',
  eventTailgating: 'Tailgating warning',
  deviceStartup: 'Device startup',
  deviceShutdown: 'Device shutdown',
};
